<template>
    <div class="textarea">
        <div v-if="title" class="label">{{ title }}</div>

        <text-editor-v2 v-if="!updatingFromParent" :model="content" :pid="getId" @updateContent="updateContent($event)"/>
    </div>
</template>

<script>
    import TextEditorV2 from "./TextEditorV2";

    export default {
        name: "Textarea",
        components: { TextEditorV2 },
        props: {
            title: {
                type: String,
                default: ''
            },
            text: String,
        },
        watch: {
            async text() {
                if (this.content !== this.text) {
                    this.toggleUpdatingFromParent();
                    this.content = this.text;
                    await this.timeout(0);
                    this.toggleUpdatingFromParent();
                }
            }
        },
        computed: {
            getId() {
                return `custom-textarea-for-${this.title.toLowerCase()}`
            },
        },
        data() {
            return {
                updatingFromParent: false,
                content: this.text,
            }
        },
        methods: {
            toggleUpdatingFromParent() {
                this.updatingFromParent = !this.updatingFromParent;
            },

            updateContent(content) {
                Vue.set(this, 'content', content);
                this.$emit('updatePassedValue', content);
            },
        }
    }
</script>

<style lang="scss">
    .textarea {
        margin-bottom: 20px;

        .label {
            display: block;
            padding: 0 0 8px;

            text-align: left;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            color: $black-1;
        }

        .text-editor-block {
            margin: 0;

            .trumbowyg-box {
                margin: 0;
            }
        }
    }
</style>